import { render, staticRenderFns } from "./GameMenu.vue?vue&type=template&id=07bf2c5b&scoped=true&"
import script from "./GameMenu.vue?vue&type=script&lang=js&"
export * from "./GameMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameMenu.vue?vue&type=style&index=0&id=07bf2c5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf2c5b",
  null
  
)

export default component.exports